import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '../../syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup, SelectBox, TextBox } from 'devextreme-react';
import { waybillService } from '../services/waybill-service';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { useNavigate } from 'react-router-dom';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import OrderStatusCell from '@/projects/syncflow/order/components/order-status-celll';

const WaybillList = () => {

    let StartDate = new Date();
    let EndDate = new Date();
    let WaybillNo: any;
    let OrderIds: any;
    let VendorCode: any;
    let ProductCode: any;

    StartDate.setDate(StartDate.getDate() - 7);


    const dateLabel = { 'aria-label': 'Date' };
    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id", "wayBillSlip"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        const x = await waybillService.getWaybillList(WaybillNo, OrderIds, VendorCode, ProductCode, StartDate, EndDate);
        return x;
    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onValueChangedStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        StartDate = e.value;
    }, []);

    const onValueChangedEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        EndDate = e.value;
    }, []);

    const onValueChangedVendor = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        VendorCode = e.value;
    }, []);

    const onValueChangedProduct = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        ProductCode = e.value;
    }, []);

    var [orderNo, setOrderNo] = useState<any>("");
    const onValueChangedOrderNo = useCallback((data: TextBoxTypes.ValueChangedEvent) => {
        setOrderNo(data.value);
        OrderIds = data.value;
    }, []);

    var [waybillNoValue, setwaybillNo] = useState<any>("");
    const onValueChangedWaybillNo = useCallback((data: TextBoxTypes.ValueChangedEvent) => {
        setwaybillNo(data.value);
        WaybillNo = data.value;
    }, []);

    const navigate = useNavigate();

    const goToDetail = (id: string) => {
        navigate(`/b2b/waybill-add/${id}`, { state: { id: id } })
    }

    const [vendorLookups] = useState(new CustomStore({
        load: waybillService.getVendorLookups
    }));

    const [productLookups] = useState(new CustomStore({
        load: waybillService.getProductLookups
    }));



    function add() {
        navigate(`/b2b/waybill-add`);
    }


    return (
        <>

            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_new")}
                        type="default"
                        icon="add"
                        onClick={add}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>



            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_start_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={StartDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_end_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={EndDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedEndDate}
                            />
                        </div>
                    </div>
                </div>

                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_customer")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                dataSource={vendorLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedVendor}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">


                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_waybill_no")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <TextBox
                                showClearButton={true}
                                onValueChanged={onValueChangedWaybillNo}
                                value={waybillNoValue}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_order_no")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <TextBox
                                showClearButton={true}
                                onValueChanged={onValueChangedOrderNo}
                                value={orderNo}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_product")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="productLookups"
                                dataSource={productLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedProduct}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}

                    columns={[
                        {
                            dataField: 'wayBillNo',
                            caption: t("syncflow:lb_waybill_no"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'wayBillDate',
                            caption: t("syncflow:lb_waybill_date"),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'orderCode',
                            caption: t("syncflow:ti_orders"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'deliveryDate',
                            caption: t("syncflow:lb_delivery_date"),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'customerName',
                            caption: t("syncflow:lb_customer"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'locationName',
                            caption: t("syncflow:lb_source_name"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'receivedBy',
                            caption: t("syncflow:lb_received_by"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'comments',
                            caption: t("syncflow:lb_comments"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'wayBillProductCount',
                            caption: t('syncflow:lb_product_count'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.wayBillStatus} isAllApproved={account?.wayBillQty == account?.receivedQty} label={(account?.wayBillProductCount + " / " + account?.receivedProductCount)} />
                                )
                            },
                        },
                        {
                            dataField: 'wayBillQty',
                            caption: t('syncflow:lb_order_quantity') + ' / ' + t('syncflow:lb_supplier_approved_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.wayBillStatus} isAllApproved={account?.wayBillQty == account?.receivedQty} label={(account?.wayBillQty + " / " + account?.receivedQty)} />
                                )
                            },
                        },
                        // {
                        //     dataField: 'orderAmount',
                        //     caption: t('syncflow:lb_order_amount') + ' / ' + t('syncflow:lb_supplier_approved_amount'),
                        //     allowFiltering: true,
                        //     allowEditing: false,
                        //     cellRender: (data: any) => {
                        //         let account = data.row.data;
                        //         return (
                        //             <OrderStatusCell statusCode={account?.invoiceStatus} isAllApproved={account?.invoiceQty == account?.receivedQty} label={("$ " + account?.invoiceAmount + " / " + "$ " + account?.receivedAmount)} />
                        //         )
                        //     },
                        // },
                        {
                            dataField: 'wayBillStatus',
                            caption: t('syncflow:lb_order_status'),
                            allowFiltering: true,
                            allowEditing: false,
                            // cellRender: order_status_cell_render
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.wayBillStatus} isAllApproved={account?.wayBillQty == account?.receivedQty} label={t('syncflow:lb_order_supplier_status_' + account?.wayBillStatus)} ></OrderStatusCell>
                                )
                            },
                        },
                        {
                            caption: t('syncflow:lb_detail'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:btn_detail")}
                                        type="default"
                                        icon='showpanel'
                                        stylingMode="contained"
                                        onClick={() => goToDetail(data.key.id)}
                                    />
                                );
                            },
                        },
                        {
                            caption: "PDF",
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t('syncflow:lb_download')}
                                        type="default"
                                        icon='download'
                                        stylingMode="contained"
                                        onClick={() => goToDownload(data.key.id, data.key.wayBillSlip)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>

        </>


    )
}
const goToDownload = (id: number, fileName: string) => {
    waybillService.getDownloadWaybillPdf(id, fileName);
}
export default WaybillList